<div class="blog-post">
  <theme-body-top/>

  <!-- Post header -->
  <div class="blog-post-header">
    <h1>${$global.title}</h1>
  </div>

  <!-- Post content + TOC sidebar -->
  <div class="content-layout">
    <div class="content-body prose-custom">
      <${$global.contentComponent || {}}>
        <div>No content</div>
      </${$global.contentComponent || {}}>
    </div>
    <if=$global.toc>
      <toc headers=$global.toc/>
    </if>
  </div>
</div>
